import { Component, Input, ChangeDetectionStrategy, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RebirthNGConfig } from '../rebirth-ng.config';

@Component({
  selector: 're-switch',
  template: "\n    <div class=\"switch {{cssClass}} {{size ? 'btn-' + size : ''}}\" (click)=\"toggle()\" [ngClass]=\"{'disabled': disabled}\"><span class=\"switch-left {{checked ? 'bg-'+ type + ' active' : ''}}\">{{onText}} </span><span class=\"switch-right {{!checked ? 'bg-'+ type + ' active' : ''}}\">{{offText}}</span></div>\n  ",
  styles: ["\n    .switch{display:inline-block;cursor:pointer;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;border:1px solid #ccc;position:relative;text-align:left;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100px;white-space:nowrap;padding:0;text-overflow:ellipsis}.switch .switch-left,.switch .switch-right{box-sizing:border-box;cursor:pointer;position:relative;display:inline-block;width:50%;line-height:2;text-align:center}.switch.disabled .switch-left,.switch.disabled .switch-right{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.switch.btn-lg{width:120px}.switch.btn-sm{width:100px}.switch.btn-xs{width:80px}\n  "],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitchComponent),
    multi: true
  }]
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() type: 'default' | 'primary' | 'success' | 'info' | 'warning' | 'danger';
  @Input() size: 'lg' | 'sm' | 'xs';
  @Input() disabled: boolean;
  @Input() onText: string;
  @Input() offText: string;
  @Input() cssClass: string;
  checked: boolean;
  private onChange = (_: any) => null;
  private onTouched = () => null;

  constructor(rebirthNGConfig: RebirthNGConfig, private changeDetectorRef: ChangeDetectorRef) {
    this.onText = rebirthNGConfig.switchBtn.onText;
    this.offText = rebirthNGConfig.switchBtn.offText;
    this.type = <any>rebirthNGConfig.switchBtn.type;
  }

  toggle() {
    if (this.disabled) {
      return;
    }
    this.onTouched();
    this.checked = !this.checked;
    this.onChange(this.checked);
  }

  writeValue(obj: any): void {
    this.checked = obj;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
